import LoadingBackDrop from 'components/loading-backdrop'
import useRedirects from 'hooks/use-redirects'

const Redirect = () => {
  useRedirects()

  return <LoadingBackDrop isloading={true} />
}

export default Redirect
